import React from 'react';
import { Redirect, Route, withRouter } from 'react-router-dom';
import { useAuthStore } from '../stores/auth-store';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const mustChangePassword = useAuthStore(
    (s) => !!s.currentUser?.mustChangePassword,
  );
  const path = rest.path;
  const isChangePasswordRoute =
    path === '/change-password' || path === '/change-password/';

  if (!isAuthenticated) {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )}
      />
    );
  }

  if (mustChangePassword && !isChangePasswordRoute) {
    return (
      <Route {...rest} render={() => <Redirect to="/change-password" />} />
    );
  }

  if (!mustChangePassword && isChangePasswordRoute) {
    return <Route {...rest} render={() => <Redirect to="/" />} />;
  }

  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

export default withRouter(ProtectedRoute);
